import { useNavigate } from "react-router-dom";
import "./hero.css";
const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <div className="section" id="hero">
      <div className="position-absolute block-top w-100">
        <h1>Welcome to the Future</h1>
        <p className="mt-3">
          At Rexla, we are reshaping how blockchain integrates into your
          everyday life. <br />
          The RXG token isn’t just a cryptocurrency—It’s the heartbeat of a
          decentralized platform designed to empower you.
        </p>
      </div>

      <div className="block-bottom position-absolute w-100">
        <button className="btn btn-primary" onClick={() => navigate("/purchase")}>
          BUY RXG
        </button>
      </div>
    </div>
  );
};

export default HeroSection;
